import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { type INavigation } from '../../types/index';

const MobileNavigation = ({
  navLinksData,
  customerSupportData,
}: {
  navLinksData: INavigation[];
  customerSupportData: INavigation[];
}) => {
  const [mobileServiceIsOpen, toggleMobileServiceOpen] = useState(false);

  return (
    <>
      <ul>
        {navLinksData.map(item =>
          item.subNav === null ? (
            <li key={item.name}>
              {item.onClick ? (
                <button
                  onClick={item.onClick}
                  className="flex w-full items-center rounded-md px-3 py-2 text-base font-sm text-black hover:bg-gray-700 hover:text-white"
                >
                  <img src={item.src} alt="" className="ml-7 mr-3 h-4 w-4" />
                  {item.name}
                </button>
              ) : item.userMenu ? (
                <Link
                  to={item.href as '/profile'}
                  className="flex items-center rounded-md px-3 py-2 text-base font-sm text-black hover:bg-gray-700 hover:text-white"
                >
                  <img src={item.src} alt="" className="ml-7 mr-3 h-4 w-4" />
                  {item.name}
                </Link>
              ) : (
                <Link
                  to={item.href as '/dashboard' | '/claims' | '/faq/questions'}
                  className="flex items-center rounded-md px-3 py-2 text-base font-sm text-black hover:bg-gray-700 hover:text-white"
                >
                  <img src={item.src} alt="" className="ml-7 mr-3 h-4 w-4" />
                  {item.name}
                </Link>
              )}
            </li>
          ) : (
            <li key={item.name}>
              <button
                onClick={() => toggleMobileServiceOpen(!mobileServiceIsOpen)}
                className="flex items-center w-full rounded-md px-3 py-2 text-base font-sm text-black hover:bg-gray-700 hover:text-white"
                aria-controls="mobile-services-menu"
                aria-expanded={mobileServiceIsOpen}
              >
                <img src={item.src} alt="" className="ml-7 mr-3 h-4 w-4" />
                {item.name}
                <svg
                  className={`w-2.5 h-2.5 ml-auto mr-4 ${mobileServiceIsOpen ? '' : 'rotate-180'}`}
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="#B0557E"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
              {mobileServiceIsOpen && (
                <ul>
                  {item.subNav!.map(subNavItem => (
                    <li key={subNavItem.name}>
                      <Link
                        to={subNavItem.href as '/services/telemedicine'}
                        className="flex items-center rounded-md px-10 py-2 text-base font-sm text-black hover:bg-gray-700 hover:text-white"
                      >
                        <img
                          src={subNavItem.src}
                          alt=""
                          className="ml-7 mr-3 h-4 w-4"
                        />
                        {subNavItem.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          )
        )}
      </ul>
      <div className="ml-7 pt-2 font-bold">Get Support</div>
      <ul>
        {customerSupportData.map(item => (
          <li key={item.name}>
            <a
              href={item.href}
              className="flex items-center rounded-md px-3 py-2 text-base font-sm text-brand-accent hover:bg-gray-700"
            >
              <img className="ml-7 mr-3 h-4 w-4" src={item.src} alt="" />
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </>
  );
};

export default MobileNavigation;
